import api from './api';

export const getMailboxes = () => api.get('/mailboxes');
export const createMailbox = (data) => api.post('/mailboxes', data);
export const getMailbox = (id) => api.get(`/mailboxes/${id}`);
export const updateMailbox = (id, data) => api.patch(`/mailboxes/${id}`, data);
export const addMailboxMember = (id, data) => api.post(`/mailboxes/${id}/members`, data);
export const removeMailboxMember = (id, userId) => api.delete(`/mailboxes/${id}/members/${userId}`);
export const getMailboxMessages = (id, params = {}) => api.get(`/mailboxes/${id}/messages`, { params });
export const deleteMailboxMessage = (id, messageId) => api.delete(`/mailboxes/${id}/messages/${messageId}`);
export const sendAsMailbox = (id, data) => api.post(`/mailboxes/${id}/messages`, data);
